import { AxiosResponse } from 'axios';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformGenerality } from 'shell/utils/consult-person/response-transformer/registry-office/generality';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { transformCivilStatus } from 'shell/utils/consult-person/response-transformer/marital-status/civil-status';

export const transformerCohabitation = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): CohabitationDetailForm => {
  const responseToTransform = response.data.payload?.risposta3002OK || {};

  const person = responseToTransform.listaSoggetti?.datiSoggetto[0] || {};

  const family = person.famigliaConvivenza;

  const executionDate = response.data.payload?.risposta3002OK?.testataRisposta?.dataDecorrenza;

  const headFamily = responseToTransform.listaSoggetti?.datiSoggetto?.find(
    (element) => element.legameSoggetto?.codiceLegame === '1'
  );

  const [residence] = headFamily?.residenza || [];

  const generality = transformGenerality(headFamily || person);
  const personVM = transformPerson(headFamily || person);
  const civilStatus = transformCivilStatus(person);

  return {
    generality: generality || undefined,
    person: personVM || undefined,
    civilStatus,
    // TODO
    residence: {
      type: residence?.tipoIndirizzo || '',
      effectiveDate: residence?.dataDecorrenzaResidenza
        ? DateTime.fromISO(residence?.dataDecorrenzaResidenza)
        : null,
      municipality: {
        id: residence?.indirizzo?.comune?.codiceIstat || '',
        description: residence?.indirizzo?.comune?.nomeComune || '',
        province: residence?.indirizzo?.comune?.siglaProvinciaIstat || '',
      },
      cap: residence?.indirizzo?.cap || '',
      locality: residence?.indirizzo?.comune?.descrizioneLocalita || '', // Fatto
      at: residence?.presso || '',
      code: residence?.indirizzo?.toponimo?.codToponimo || '',
      kind: residence?.indirizzo?.toponimo?.specie || '',
      name: residence?.indirizzo?.toponimo?.denominazioneToponimo || '',
      source: residence?.indirizzo?.toponimo?.toponimoFonte || '',
      kindCode: residence?.indirizzo?.toponimo?.codSpecie || '',
      kindSource: residence?.indirizzo?.toponimo?.specieFonte || '',
      number: residence?.indirizzo?.numeroCivico?.numero || '',
      letter: residence?.indirizzo?.numeroCivico?.lettera || '',
      exponent: residence?.indirizzo?.numeroCivico?.esponente1 || '',
      color: residence?.indirizzo?.numeroCivico?.colore || '',
      civicCode: residence?.indirizzo?.numeroCivico?.codiceCivico || '',
      sourceCivic: residence?.indirizzo?.numeroCivico?.civicoFonte || '',
      metric: residence?.indirizzo?.numeroCivico?.metrico || '',
      prog: residence?.indirizzo?.numeroCivico?.progSNC || '',
      court: residence?.indirizzo?.numeroCivico?.civicoInterno?.corte || '',
      scale: residence?.indirizzo?.numeroCivico?.civicoInterno?.scala || '',
      firstIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.interno1 || '',
      exponentFirstIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.espInterno1 || '',
      externalScale: residence?.indirizzo?.numeroCivico?.civicoInterno?.scalaEsterna || '',
      secondary: residence?.indirizzo?.numeroCivico?.civicoInterno?.secondario || '',
      secondaryIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.interno2 || '',
      exponentSecondaryIntern: residence?.indirizzo?.numeroCivico?.civicoInterno?.espInterno2 || '',
      floor: residence?.indirizzo?.numeroCivico?.civicoInterno?.piano || '',
      nui: residence?.indirizzo?.numeroCivico?.civicoInterno?.nui || '',
      isolated: residence?.indirizzo?.numeroCivico?.civicoInterno?.isolato || '',
    },
    accordionCohabitation: {
      municipalityIdentifier: family?.idFamigliaConvivenzaComune?.idFamigliaConvivenza,
      istatCode: family?.idFamigliaConvivenzaComune?.idFamigliaConvivenzaComuneIstat,
      idANPR: family?.idFamigliaConvivenzaANPR,
      originDate: family?.dataOrigineFamigliaConvivenza
        ? DateTime.fromISO(family?.dataOrigineFamigliaConvivenza)
        : null,
      kindCohabitation: family?.specieConvivenza,
      nameCohabitation: family?.denominazioneConvivenza,
      tipoScheda: family?.tipoScheda,
      tipoMovimentazione: family?.tipoMovimentazione,
      presenzaFamigliaCoabitante: family?.presenzaFamigliaCoabitante,
      motivoCostituzione: family?.motivoCostituzione,
      famigliaAire: family?.famigliaAire,
      // cohabitationComponents?: Array<CohabitationComponents>;
    },
    editDataControl: {
      dateValidity: executionDate ? DateTime.fromISO(executionDate) : null,
    }, // for cancellation
  };
};
